export default __webpack_public_path__ + "static/media/bo.6d464814.svg";